import { objectToCssProperties } from "@/helpers/objectToCssProperties";
import Link from "@/components/Link";
import { BuilderBlockProps, CustomUrl } from "@/types";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { CSSProperties, FC, PropsWithChildren } from "react";
import { getHrefFromCustomUrlPlugin } from "@/helpers";

type InteractiveBlockProps = {
  link?: {
    href: CustomUrl;
    dlt: string;
    dld: string;
  };
  interactionStyles: {
    childClass: string;
    hoverStyle?: CSSProperties;
    activeStyle?: CSSProperties;
    focusStyle?: CSSProperties;
    focusVisibleStyle?: CSSProperties;
    visitedStyle?: CSSProperties;
  }[];
} & BuilderBlockProps &
  Pick<BuilderProps, "builderBlock">;

export const InteractiveBlock: FC<PropsWithChildren<InteractiveBlockProps>> = ({
  children,
  attributes,
  link,
  interactionStyles = [],
  builderBlock,
}) => {
  const css = interactionStyles
    .map(
      ({
        childClass,
        hoverStyle,
        activeStyle,
        focusStyle,
        focusVisibleStyle,
        visitedStyle,
      }) => {
        const styles: string[] = [];
        if (hoverStyle && Object.keys(hoverStyle).length) {
          styles.push(
            `.${builderBlock.id}:hover${childClass ? ` .${childClass}` : ""} { ${objectToCssProperties(
              hoverStyle,
            )} }`,
          );
        }
        if (activeStyle && Object.keys(activeStyle).length) {
          styles.push(
            `.${builderBlock.id}:active${childClass ? ` .${childClass}` : ""} { ${objectToCssProperties(
              activeStyle,
            )} }`,
          );
        }
        if (focusStyle && Object.keys(focusStyle).length) {
          styles.push(
            `.${builderBlock.id}:focus${childClass ? ` .${childClass}` : ""} { ${objectToCssProperties(
              focusStyle,
            )} }`,
          );
        }
        if (focusVisibleStyle && Object.keys(focusVisibleStyle).length) {
          styles.push(
            `.${builderBlock.id}:focus-visible${childClass ? ` .${childClass}` : ""} { ${objectToCssProperties(
              focusVisibleStyle,
            )} }`,
          );
        }
        if (visitedStyle && Object.keys(visitedStyle).length) {
          styles.push(
            `.${builderBlock.id}:visited${childClass ? ` .${childClass}` : ""} { ${objectToCssProperties(
              visitedStyle,
            )} }`,
          );
        }
        return styles.join("\n");
      },
    )
    .join("\n");

  return (
    <>
      <style>{css}</style>
      {link?.href ? (
        <Link
          {...attributes}
          href={getHrefFromCustomUrlPlugin(link.href)}
          dld={link.dld}
          dlt={link.dlt}
        >
          {children}
        </Link>
      ) : (
        <div {...attributes}>{children}</div>
      )}
    </>
  );
};
